import { Outlet } from 'react-router-dom'

import { CompensationsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/compensations/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, error, loading } = useQuery(CompensationsRootPageDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const canSeeCompensationsSettings =
    data?.compensations._policies.settingsSeeCompensationsSettings.can ?? false
  const compensationsEnabled =
    data?.compensations._policies.sidebarSeeCompensationsTopLevelItem.can ?? false

  if (loading || error || !data) return null

  return (
    <AuthorizeUser authorizeFn={() => canSeeCompensationsSettings}>
      <CollectionsBootstrap>
        <Outlet context={{ compensationsEnabled }} />
      </CollectionsBootstrap>
    </AuthorizeUser>
  )
}

export default RootPage
